import { checkRole, findServiceArea, getAddressDetails, getInvalidControls, isEdit, isOneHourViolation, spaceTypeList } from './../../../utils/utils.common';
import { parseAddress } from 'us-address-parser';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays } from '../../../utils/utils.common';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
// import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { MemberService } from 'src/app/service/member-service/member.service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { PrimaryDiagnosisService } from 'src/app/service/primary-diagnosis-service/primary-diagnosis.service';
import { ServiceAreasService } from 'src/app/service/service-areas-service/service-areas.service';
import { ModifierCodesService } from 'src/app/service/modifier-codes-service/modifier-codes.service';
import { TripPurposesService } from 'src/app/service/trip-purposes/trip-purposes.service';
import { EquipmentService } from 'src/app/service/equipment-service/equipment.service';
import { ProTipsService } from 'src/app/service/ProTips/pro-tips.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserRoles } from 'src/app/service/menu-service/menu.service';
import { PayorService } from 'src/app/service/payor/payor.service';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @Input('editId') editId;
  @Output() onUpdate = new EventEmitter<string>();

  newTripForm: FormGroup;
  addonsServicesForm: FormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  minDate = moment().tz(this.timeZone).startOf('day');
  dateMultiDays: any = null;
  user;
  memberList = [];
  fundingSourceList = [];
  tripPurposeList = [];
  modifierList = [];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj;
  addressPickerObj;
  suggestedPickupTime;
  isCalculating = false;
  isEditDataLoaded = false;
  allowSpaceTypesList: any;
  filteredSpaceTypeList: any;
  is1HourException = false;
  isEnabledOneHourException = true;
  isPossibility = false;
  possibilityObj;
  payorList:any;
  isAllowAuthorizationNumber = false;
  isEnableExpectedAppointment = false;
  version = '2';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private equipmentService: EquipmentService,
    private proTipsService: ProTipsService,
    private driverService: DriversService,
    private toastr: ToastrService,
    private tripPurposesService: TripPurposesService,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private modifierCodesService: ModifierCodesService,
    private levelOfServiceService: LevelOfServiceService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private serviceArea: ServiceAreasService,
    private payorService: PayorService
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }


    this.newTripForm = this.fb.group({
      company: ['', Validators.required],

      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: ['', Validators.required],
      jobDestinationLongitude: ['', Validators.required],
      zipCodeDest: [''],
      cityDest: [''],
      stateDest: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: ['', Validators.required],
      jobOriginLongitude: ['', Validators.required],
      zipCodeOrg: [''],
      cityOrg: [''],
      stateOrg: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      spaceType: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['', Validators.required],
        cellPhone: [''],
        email: [''],
        preDob: [moment()],
        dob: [''],
        weight: [''],
        gender: [''],
        clientId: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      cooperate: ['', Validators.required],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      preActualAppointmentTime: ["", Validators.required],
      actualAppointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      viewStatus: ["created", Validators.required],

      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      multidates: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[], Validators.required],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      preRecurringEndDate: [null],
      recurringEndDate: [''],
      isStandingOrder: [false],
      isRecurring: [false],
      recurringDays: this.fb.array([]),
      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: [null],
      serviceAreaDest: [null],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      isConfirmedTrip: [false],
      isWillCall: [false],
      payorId: [''],
      authorizationNumber: ['']
    });
    this.addStandingDays();


    if (this.editId) {
      this.tripId = this.editId;
    }
    this.makeCompulsoryCalls();
    this.formControlsListeners();
  }

  formControlsListeners() {
    this.newTripForm.controls['jobOriginAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });
    this.newTripForm.controls['jobDestinationAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });
    
        this.newTripForm.valueChanges
      .subscribe(formValue => {
        const requiredFields = [
          'jobOriginLatitude',
          'jobOriginLongitude',
          'jobDestinationLatitude',
          'jobDestinationLongitude',
          'jobDestinationAddress',
          'jobOriginAddress',
          'cooperate',
          'spaceType',
          'scheduleTime',
          // 'milage',
          'appointmentTime',
          // 'serviceArea'
        ];
        const isValid = requiredFields.every(
          field => {

            return formValue[field] !== null && formValue[field] !== ''
          }
        );
        this.possibilityObj = isValid ? formValue : null;
      });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getConfigurations()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1]) => {

        if (res1) {
          this.levelOfServiceList = res1.levelofservices;
          this.spaceTypeMainList = res1.spacetypes;
        }
        this.getMemberList();
        this.getTripPurposeList();
        this.getFundingSourceList();
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        this.getServiceAreaList();
        this.getUser();
        this.getPayorList();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.user.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.allowAuthorizationNumber;
          } 
          else if (this.user.cooperate && this.user.cooperate.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.cooperate.allowAuthorizationNumber;
          }
          this.allowSpaceTypesList = this.user.cooperate ? this.user.cooperate.allowSpaceTypes : this.user.allowSpaceTypes;
          this.filteredSpaceTypeList = this.spaceTypeMainList.filter(spaceType =>
            this.allowSpaceTypesList.includes(spaceType._id)
          );
          this.timeZone = this.user.company.timeZone;
          this.todayDate = moment().tz(this.timeZone);
          this.minDate = this.tripId ? null : moment().tz(this.timeZone).startOf('day');
          this.setCorporateUser(user)

          this.newTripForm.patchValue({
            company: this.user.company._id,
            cooperate: this.user._id,
            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),
            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
            preActualAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            actualAppointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
            jobDestinationAddress : user.address ? user.address : ''
          });
          this.getDriverList();

          if (this.tripId) {
            this.getTripDetails();
          }

          this.isAllowRates = checkRole(this.user);
          if (this.user.company 
            && this.user.company.hasOwnProperty('hideOneHourException')
            && this.user.company.hideOneHourException
          ) {
            this.isEnabledOneHourException = false;
          }
        }




      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const preData = JSON.parse(JSON.stringify(data));
          // remove standing order
          delete preData.recurringDays;
          delete preData.addonServices;

          const originParsed = preData.jobOriginAddress ? parseAddress(preData.jobOriginAddress) : null;
          const destinationParsed = preData.jobDestinationAddress ? parseAddress(preData.jobDestinationAddress) : null;

          this.newTripForm.patchValue({
            ...preData,
            viewStatus: 'updated',
            preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
            preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
            preActualAppointmentTime: moment(preData.actualAppointmentTime).tz(this.timeZone),
            preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
            priorityClient: {
              ...preData.priorityClient,
              preDob: preData.priorityClient && preData.priorityClient.dob ? moment(preData.priorityClient.dob).tz(this.timeZone) : '',
              dob: preData.priorityClient.dob,
            },
            // los: preData.spaceType.los, // Patch LOS directly from spaceType
            los: preData.los,
            spaceType: preData.spaceType,
            payorId: preData.payorId ? preData.payorId : '',
            cityOrg: originParsed ? originParsed.city : '',
            stateOrg: originParsed ? originParsed.state : '',
            cityDest: destinationParsed ? destinationParsed.city : '',
            stateDest: destinationParsed ? destinationParsed.state : ''
          });
          if (this.isEnabledOneHourException) {
            this.is1HourException = preData.isAnHourException;
          }
          
          this.onSpaceTypeChange(data.spaceType);

          if (data.cooperate) {
            this.getAddonsList(data.cooperate);
          }

          if (data.addonServices) {
            this.addAddonsItem(data.addonServices);
          }

          if (data.status === "standing") {
            this.addStandingDays(data.recurringDays);
          }

          setTimeout(() => {
            this.isEditDataLoaded = true;
          }, 3000);
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }


  getMemberList() {
    const queryParam = {
      accountStatus: 'active',
    }

    this.memberService
      .getMembers(queryParam)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberList = data;

        }
      });
  }

  getTripPurposeList() {
    this.tripPurposesService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSourceList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getModifierList() {
    this.modifierCodesService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getConfigurations() {
    return this.assignTripService.getConfigurations({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    this.primaryDiagnosisService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user.company._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get formValues() {
    return this.newTripForm.value;
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as FormArray;
  }

  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    let preValues;
    if (items.length === 0) {
      preValues = this.newTripForm.value
    } else {
      preValues = items.at(items.length - 1).value;
    }

    let hour = items.length === 0 ? 1 : 2;
    // if (!items.invalid) {
    items.push(
      this.fb.group({
        jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
        jobDestinationLatitude: [preValues.jobOriginLatitude, Validators.required],
        jobDestinationLongitude: [preValues.jobOriginLongitude, Validators.required],
        zipCodeDest: [preValues.zipCodeOrg],
        cityDest: [preValues.cityOrg],
        stateDest: [preValues.stateOrg],
        serviceAreaDest: [preValues.serviceArea],

        jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
        jobOriginLatitude: [preValues.jobDestinationLatitude, Validators.required],
        jobOriginLongitude: [preValues.jobDestinationLongitude, Validators.required],
        zipCodeOrg: [preValues.zipCodeDest],
        cityOrg: [preValues.cityDest],
        stateOrg: [preValues.stateDest],
        serviceArea: [preValues.serviceAreaDest],

        preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        appointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        companyNote: [''],
        isWillCall: [false],

        originAddressAdditional: this.fb.group({
          modifier: [preValues.destinationAddressAdditional.modifier],
          modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
          floor: [preValues.destinationAddressAdditional.floor],
          room: [preValues.destinationAddressAdditional.room],
          aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
          place: [preValues.destinationAddressAdditional.place],
          phone: [preValues.destinationAddressAdditional.phone]
        }),
        destinationAddressAdditional: this.fb.group({
          modifier: [preValues.originAddressAdditional.modifier],
          modifierTwo: [preValues.originAddressAdditional.modifierTwo],
          floor: [preValues.originAddressAdditional.floor],
          room: [preValues.originAddressAdditional.room],
          aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
          place: [preValues.originAddressAdditional.place],
          phone: [preValues.originAddressAdditional.phone]
        }),


      })
    );
    // }
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    items.removeAt(index);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as FormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as FormArray;
    items.removeAt(index);
  }


  onSelectMember(event) {
    let member;
    if (event) {
      member = this.memberList.find((member) => member._id === event);

    }
    this.setMemberDetails(member);
  }

  setMemberDetails(member) {
    try {
      if (member) {
        console.log('member', member);
        const zip = member.homeAddress.zipCode;
        const myServiceArea = findServiceArea(zip, this.serviceAreaList);
        const aptOrSuite = member.homeAddress && member.homeAddress.aptOrSuite || '';
        const covidStatus = member.covidStatus || '';

        let combinedNotes: string[] = [];

        if (aptOrSuite) {
          combinedNotes.push(`APT: ${aptOrSuite}`);
        }

        if (covidStatus) {
          combinedNotes.push(`Med Cond: ${covidStatus}`);
        }

        let companyNote = combinedNotes.join(' // ');
        if (companyNote) {
          companyNote += ' (take precaution as per SOPs)';
        }

        let memberPayload;
        memberPayload = {
          priorityClient: member,
          companyNote: companyNote,
          isVipTrip: member.type === "vip" ? true : false,
          originAddressAdditional: {
            phone: member.contactNumber,
            dispatchNoteTwo: member.note + " ----------  " + member.privateNote,
          }
        }

        if (member.homeAddress && member.homeAddress.address) {
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode,
            serviceArea: myServiceArea ? myServiceArea : null
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
              aptOrSuite: aptOrSuite
            },
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.los) {
          memberPayload = { ...memberPayload, los: member.los };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient: {
              ...memberPayload.priorityClient,
              preDob: moment(member.dob),
              dob: member.dob
            }

          };

          console.log('memberPayload', memberPayload);
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType };
        }

        this.newTripForm.patchValue(memberPayload);
      } else {
        this.newTripForm.patchValue({
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        cityOrg: addressDetails.city,
        stateOrg: addressDetails.state,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        cityOrg: addressDetails.city,
        stateOrg: addressDetails.state,
        serviceArea: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        cityDest: addressDetails.city,
        stateDest: addressDetails.state,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        cityDest: addressDetails.city,
        stateDest: addressDetails.state,
        serviceAreaDest: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

   onOriginAddressChange(index?: number) {
    const clearedValue = {
      jobOriginLatitude: '',
      jobOriginLongitude: '',
      zipCodeOrg: '',
      cityOrg: '',
      stateOrg: '',
    };
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue(clearedValue);
    } else {
      this.newTripForm.patchValue(clearedValue);
    }
  }

  onDestinationAddressChange(index?: number) {
    const clearedValue = {
      jobDestinationLatitude: '',
      jobDestinationLongitude: '',
      zipCodeDest: '',
      cityDest: '',
      stateDest: '',
    };
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue(clearedValue);
    } else {
      this.newTripForm.patchValue(clearedValue);
    }
  }

  async calculateSuggestedPickupTime() {
    if (!this.isEnableExpectedAppointment) return;
    if (this.editId) {
      // stop calculateSuggestedPickupTime() only once
      if (!this.isEditDataLoaded) return;
    }
    console.log('calculateSuggestedPickupTime');
    this.suggestedPickupTime = null;
    this.is1HourException = false;
    const {
      jobOriginAddress,
      jobOriginLatitude,
      jobOriginLongitude,
      jobDestinationAddress,
      jobDestinationLatitude,
      jobDestinationLongitude,
      actualAppointmentTime
    } = this.newTripForm.value;

    // stop if any of the following doesn't have a value
    if (!(jobOriginAddress && jobDestinationAddress)) return;
    if (!(jobOriginLatitude && jobOriginLongitude)) return;
    if (!(jobDestinationLatitude && jobDestinationLongitude)) return;


    this.isCalculating = true;
    const queryParams = {
      start: [jobOriginLongitude, jobOriginLatitude].toString(),
      end: [jobDestinationLongitude, jobDestinationLatitude].toString(),
    };


    try {
      const minutes = await this.calculateTime(queryParams);
      this.is1HourException = (minutes + 15) > 60 ? true : false;

      const estimatedPickupTime = moment(actualAppointmentTime).tz(this.timeZone).subtract(minutes, 'minutes');
      this.suggestedPickupTime = estimatedPickupTime;

      const newScheduleTime = estimatedPickupTime.subtract(20, 'minutes');
      this.newTripForm.patchValue({
        preScheduleTime: newScheduleTime,
        scheduleTime: newScheduleTime.toISOString(),

        preAppointmentTime: newScheduleTime.clone().add(minutes, 'minutes'),
        appointmentTime: newScheduleTime.clone().add(minutes, 'minutes').toISOString(),
      });

      this.isCalculating = false;
    } catch (error) {
      this.isCalculating = false;
    }
  }

  async calculateTime(queryParams) {
    const res: any = await this.assignTripService.calculateMiles(queryParams).pipe(takeUntil(componentDestroyed(this))).toPromise();
    let duration = 60;
    if (
      res &&
      res.features &&
      res.features[0] &&
      res.features[0].properties &&
      res.features[0].properties.segments &&
      res.features[0].properties.segments[0] &&
      res.features[0].properties.segments[0].duration
    ) {
      duration = res.features[0].properties.segments[0].duration / 60;
    }

    return duration;
  }

  setPickTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });


      // if (!this.tripId && !items.at(index).value.isWillCall) {
      //   items.at(index).patchValue({
      //     preAppointmentTime: moment(event).add(1, 'hours')
      //   });
      // }

    } else {
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      // if (!this.tripId) {
      //   this.newTripForm.patchValue({
      //     preAppointmentTime: moment(event).add(1, 'hours'),
      //     preActualAppointmentTime: moment(event).add(1, 'hours'),
      //     actualAppointmentTime: moment(event).add(1, 'hours').toISOString()
      //   });
      // }
      // if (this.tripId && this.newTripForm.value.isWillCall) {
      //   this.newTripForm.patchValue({
      //     preAppointmentTime: moment(event).add(1, 'hours')
      //   });
      // }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

    } else {
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
        // preActualAppointmentTime: moment(event).tz(this.timeZone, true),
        // actualAppointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
    }
  }

  setActualAppointmentTimeChange(event) {
    this.newTripForm.patchValue({
      actualAppointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
    this.calculateSuggestedPickupTime(); // calling order matters
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as FormArray;

    if (event.target.checked) {
      const time = items.at(index)['controls'].preScheduleTime.value;
      time.set('hour', 23)
      time.set('minute', 59);

      items.at(index).patchValue({
        preScheduleTime: time,
        scheduleTime: time.toISOString(),

        preAppointmentTime: time.clone(),
        appointmentTime: time.clone().toISOString()
      })

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      items.at(index)['controls'].preScheduleTime.enable();
    }
  }

  setWillCallInEdit(event) {
    if (event.target.checked) {
      const schTime = this.newTripForm['controls'].preScheduleTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preScheduleTime.setValue(schTime);
      this.newTripForm['controls'].preScheduleTime.disable();

      const aptTime = this.newTripForm['controls'].preAppointmentTime.value;
      aptTime.set('hour', 23)
      aptTime.set('minute', 59)
      this.newTripForm['controls'].preAppointmentTime.setValue(aptTime);
      this.newTripForm['controls'].preAppointmentTime.disable();
    } else {
      this.newTripForm['controls'].preScheduleTime.enable();
      this.newTripForm['controls'].preAppointmentTime.enable();
    }
  }

  setCorporateUser(corporate) {
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      },
      cooperate: ''
    });

    // const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (corporate) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: corporate.displayName,
          profileImageURL: corporate.profileImageURL
        },
        cooperate: corporate._id
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(corporate._id);

    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
  }

  onSelectLOS(losId) {
    this.spaceTypeList = [];
    if (!losId) {
      this.newTripForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType);
    if (!spaceTypes.length) {
      this.newTripForm.patchValue({
        spaceType: '',
      });
    }
  }
  onSelectSpaceType() {
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    this.filteredAddonsList = this.addonsList.filter(item => item.spaceType === this.newTripForm.value.spaceType)
  }

  onSpaceTypeChange(spaceTypeId: string) {
    this.newTripForm.patchValue({ los: '' });
    if (spaceTypeId) {
      const selectedSpaceType = this.filteredSpaceTypeList.find(item => item._id === spaceTypeId);
      if (selectedSpaceType && selectedSpaceType.los) {
        this.newTripForm.patchValue({
          los: selectedSpaceType.los,
        });
      }
    }
  }




  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  //  Missing  

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTipsService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }


  get multidatesForm() {
    return this.newTripForm.get('multidates') as FormArray;
  }

  addMultidateEntry(): void {
    if (!this.dateMultiDays) return;

    const dayStart = moment(this.dateMultiDays).tz(this.timeZone).startOf('day');

    const exist = this.multidatesForm.value.some(
      item => item.preDate === dayStart.format('MM/DD/YYYY')
    );
    if (exist) return;

    this.multidatesForm.push(this.fb.group({
      preDate: [dayStart.format('MM/DD/YYYY')],
      date: [dayStart.toISOString()]
    }));

    this.dateMultiDays = null;
  }

  removeMultidate(index: number): void {
    this.multidatesForm.removeAt(index);
  }

  get standingOrderForm() {
    return this.newTripForm.get('recurringDays') as FormArray;
  }

  addStandingDays(preStandingList?) {

    const recurringDaysItems = this.newTripForm.get('recurringDays') as FormArray;
    if (preStandingList) {

      for (let preItem of preStandingList) {
        const index = recurringDaysItems.controls.findIndex(item => item.value.day === preItem.day);
        if (index > -1) {
          recurringDaysItems.at(index).patchValue({
            checked: true,
            driver: preItem.driver ? preItem.driver : 'null'
          });

          recurringDaysItems.at(index)['controls'].driver.enable();
        }
      }
      return;
    }

    for (let dayItem of getstandingOrderDays) {
      recurringDaysItems.push(
        this.fb.group({
          label: [dayItem.label],
          day: [dayItem.day],
          checked: [false],
          driver: [{ value: 'null', disabled: true }],
        })
      );
    }
  }

  onChangeStandingDay(event, form) {
    if (event) {
      form.controls.driver.enable();
    } else {
      form.controls.driver.disable();
    }
  }

  onChangeStandingStatus(event) {
    const isEnabled = JSON.parse(event.target.value);
    if (this.tripId && !isEnabled) {
      sweetAlert('Alert', 'Are you sure you want to inactive standing orders? This action will reset the recurring date to today and remove all the future existing trips.', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            const standingOrderDate = moment().tz(this.timeZone, true).startOf('day');
            if (this.newTripForm.value.recurringEndDate) {
              const previousDate = moment(this.newTripForm.value.recurringEndDate).tz(this.timeZone, true).startOf('day');
              if (previousDate.isAfter(standingOrderDate)) {
                this.newTripForm.patchValue({
                  preRecurringEndDate: standingOrderDate,
                  recurringEndDate: standingOrderDate.toISOString(),
                  isRecurring: isEnabled
                });
              } else {
                this.newTripForm.patchValue({
                  isRecurring: isEnabled
                });
              }
            } else {
              this.newTripForm.patchValue({
                preRecurringEndDate: standingOrderDate,
                recurringEndDate: standingOrderDate.toISOString(),
                isRecurring: isEnabled
              });
            }
          } else {
            this.newTripForm.patchValue({
              isRecurring: true
            });
          }
        });
    } else {
      this.newTripForm.patchValue({
        isRecurring: isEnabled
      });
    }
  }

  setStandingDateChange(event) {
    if (event) {
      this.newTripForm.patchValue({
        recurringEndDate: moment(event).tz(this.timeZone, true).startOf('day').toISOString()
      });
    }
  }

  async onCreateTrip() {
    this.submitted = true;
    if (this.newTripForm.invalid) return;
    let payload = {
      ...this.newTripForm.value,
      payorId: this.newTripForm.value.payorId ? this.newTripForm.value.payorId : null,
    };

    // Display-only fields, not part of the trip payload
    delete payload.cityOrg;
    delete payload.stateOrg;
    delete payload.cityDest;
    delete payload.stateDest;
    if (payload.tripLegs && payload.tripLegs.length) {
      payload.tripLegs = payload.tripLegs.map((leg: any) => {
        const { cityOrg, stateOrg, cityDest, stateDest, ...legRest } = leg;
        return legRest;
      });
    }

    if (payload.tripLegs && payload.tripLegs.length) {
      const isAllow = await this.isAllowDifferentServiceDates(payload)
      if (!isAllow) {
        return;
      }
    }

    if (!payload.isRecurring) {
      payload.multidates = (payload.multidates || []).map((item: any) => item.date);
    } else {
      delete payload.multidates;
    }

    const checkPayload = {
      client: payload.client,
      jobOriginAddress: payload.jobOriginAddress,
      jobDestinationAddress: payload.jobDestinationAddress,
      scheduleTime: payload.scheduleTime
    };

    if(!this.isEnableExpectedAppointment){
      payload.actualAppointmentTime = payload.appointmentTime;
    }


    if (this.tripId) {
      checkPayload['_id'] = this.tripId;
      this.apiRequest(payload);
    } else {
      this.assignTripService.checkTripExists(checkPayload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.apiRequest(payload);
          }
        }, err => {
          console.log('error here', err);
          if (err && err.error && err.error.isDuplicate) {
            sweetAlert('Error', 'Trip already exists for this client.', 'error', 'OK');
          }
          // isDuplicate is false when we edit the trip and do not change Member, Both Addresses and Pickup. 
          if (err && err.error && !err.error.isDuplicate) {
            this.apiRequest(payload);
          }
        });
    }
  }

  apiRequest(payload) {
    if (payload.isRecurring) {
      const scheduleTime = moment(payload.scheduleTime).tz(this.timeZone);
      const recurringEndDate = payload.recurringEndDate ? moment(payload.recurringEndDate).tz(this.timeZone) : null;
      const isInvalidEndDate = !recurringEndDate || recurringEndDate.diff(scheduleTime, 'months', true) > 6;

      if (isInvalidEndDate) {
        sweetAlert(
          'Warning',
          'Are you sure the standing order should exceed the plan of care or 6 month window? Do you wish to continue?',
          'warning',
          'Yes, Continue',
          'Modify Dates'
        ).then((result) => {
          if (result.value) {
            this.proceedTripCreation(payload);
          }
        });
        return;
      }
    }

    this.proceedTripCreation(payload);
  }

  async isAllowDifferentServiceDates(payload) {
    let blnReturn = true;
    const legA_ScheduleTime = moment(payload.scheduleTime).tz(this.timeZone);
    const legB_ScheduleTime = moment(payload.tripLegs[0].scheduleTime).tz(this.timeZone);
    const isLegB_SameAsLegA = legA_ScheduleTime.isSame(legB_ScheduleTime, 'day');
    let isLegC_SameAsLegA = undefined;

    if (payload.tripLegs.length > 1) {
      const legC_ScheduleTime = moment(payload.tripLegs[1].scheduleTime).tz(this.timeZone);
      isLegC_SameAsLegA = legA_ScheduleTime.isSame(legC_ScheduleTime, 'day');
    }

    if (!isLegB_SameAsLegA || (isLegC_SameAsLegA !== undefined && !isLegC_SameAsLegA)) {
      const result = await sweetAlert('Alert', 'The service date for the return trip does not match the service date of the Leg-A. Do you wish to continue?', 'warning', 'Yes', 'No');
      if (!result.value) blnReturn = false;
    }
    return blnReturn;
  }

  proceedTripCreation(payload) {
    // checking standing orders
    if (payload.isRecurring) {
      let recurringDays = [];
      for (let standingOrderDay of payload.recurringDays) {
        if (standingOrderDay.checked) {
          recurringDays.push({ ...standingOrderDay, driver: standingOrderDay.driver === 'null' ? null : standingOrderDay.driver })
        }
      }

      if (recurringDays.length) {
        payload.recurringDays = recurringDays;
        payload.status = 'standing';
        payload.jobStatus = 'standing';
      }
      if (!payload.milage)
        delete payload.milage
    } else {
      delete payload.recurringDays
      delete payload.status
      delete payload.jobStatus
    }

    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
    }
    if (this.isEnabledOneHourException) {
      payload.isAnHourException = isOneHourViolation(payload, this.timeZone);
    }

    this.assignTripService
      .createNewTripV2(payload, this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId) {
            this.onUpdate.emit(data);
          } else {
            this.router.navigate(['trips'], {
              state: { tripId: data._id }
            });
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }



  openAddMemberModal(member) {
    this.addMemberModalObj = member;
  }

  onSaveMember(evt) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex(member => member._id === evt._id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }

      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id,
        originAddressAdditional: {
          aptOrSuite: evt.homeAddress.aptOrSuite
        }

      });
      this.setMemberDetails(evt);

      this.addMemberModalObj = null;

      // Refresh the dropdown by triggering change detection
    }
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as FormArray;
    if (!event) return;

    const parsed = event.address ? parseAddress(event.address) : null;
    const city = parsed ? parsed.city : '';
    const state = parsed ? parsed.state : '';

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state
      });
      this.calculateSuggestedPickupTime();
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state
      });
      this.calculateSuggestedPickupTime();
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode,
        cityOrg: city,
        stateOrg: state
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode,
        cityDest: city,
        stateDest: state
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  isAllowToAddMember(): boolean {
    if (!this.user || !Array.isArray(this.user.roles) || this.user.roles.length === 0) {
      return false;
    }

    return [UserRoles.CORPORATE, UserRoles.FULL_ACCESS].includes(this.user.roles[0]);
  }

  // // This prevents browser refresh/tab close
  // @HostListener('window:beforeunload', ['$event'])
  // handleBeforeUnload($event: any): void {
  //   $event.returnValue = true;
  // }

    getPayorList() {

    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  ngOnDestroy(): void {
  }

}
